import Vue from 'vue'
import { mapGetters } from 'vuex'
import Healthcare from './healthcare.vue'

/**
 * This is not a standalone plan and needs to be attached to a specific plan.
 * They are displayed at the same level but are mounted and unmounted following the associated plan.
 */
export default {
  beforeMount() {
    this.$_attachedHealthcareVm = new Vue({
      name: 'AttachedHealthcare',
      parent: this.$parent,
      computed: {
        ...mapGetters(['healthcareAvailable']),
      },
      render() {
        return this.healthcareAvailable ? <Healthcare /> : null
      },
    }).$mount()
  },

  mounted() {
    const { parentElement, nextSibling } = this.$el
    const attachedHealthcareEl = this.$_attachedHealthcareVm.$el
    if (nextSibling) {
      parentElement.insertBefore(attachedHealthcareEl, nextSibling)
    } else {
      parentElement.appendChild(attachedHealthcareEl)
    }
  },

  beforeDestroy() {
    const attachedHealthcareEl = this.$_attachedHealthcareVm.$el
    if (attachedHealthcareEl?.parentElement) {
      attachedHealthcareEl.parentElement.removeChild(attachedHealthcareEl)
    }
    this.$_attachedHealthcareVm.$destroy()
  },
}
